import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    width: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  datePicker: {
    width: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      '& .MuiTextField-root': {
        width: '100% !important',
        '& .MuiInputBase-root': {
          height: '40px'
        }
      }
    }
  }
}))
